import { render } from "./PlaceDetail.vue?vue&type=template&id=17abb74b"
import script from "./PlaceDetail.vue?vue&type=script&lang=js"
export * from "./PlaceDetail.vue?vue&type=script&lang=js"

import "./PlaceDetail.vue?vue&type=style&index=0&id=17abb74b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__